import { render, staticRenderFns } from "./ChoujianDetail.vue?vue&type=template&id=771fb68c&scoped=true"
import script from "./ChoujianDetail.vue?vue&type=script&lang=js"
export * from "./ChoujianDetail.vue?vue&type=script&lang=js"
import style0 from "./ChoujianDetail.vue?vue&type=style&index=0&id=771fb68c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "771fb68c",
  null
  
)

export default component.exports